/** Извлекает только цифры из строки телефона. */
function digitsOnly(value: string): string {
  return value.replace(/\D/g, '');
}

/**
 * Нормализует телефон из ручного ввода, autofill браузера или tel:-ссылки.
 * Возвращает E.164-подобный формат (+79991234567) или пустую строку.
 */
export function parsePhoneInput(raw: string | null | undefined): string {
  if (raw == null) return '';
  let value = String(raw).trim();
  if (!value) return '';

  const lower = value.toLowerCase();
  if (lower.startsWith('tel:')) {
    value = value.slice(4).trim();
  }

  let digits = digitsOnly(value);
  if (!digits) return '';

  // Россия: 8XXXXXXXXXX → +7XXXXXXXXXX
  if (digits.length === 11 && digits.startsWith('8')) {
    digits = `7${digits.slice(1)}`;
  }
  // 9XXXXXXXXX → +79XXXXXXXXX
  if (digits.length === 10 && digits.startsWith('9')) {
    digits = `7${digits}`;
  }

  if (digits.length < 10 || digits.length > 15) {
    return '';
  }

  return `+${digits}`;
}

/** Форматирует нормализованный телефон для отображения в поле. */
export function formatPhoneDisplay(raw: string | null | undefined): string {
  const normalized = parsePhoneInput(raw);
  if (!normalized) {
    return raw?.trim() || '';
  }

  const digits = digitsOnly(normalized);
  if (digits.length === 11 && digits.startsWith('7')) {
    return `+7 ${digits.slice(1, 4)} ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9, 11)}`;
  }

  return normalized;
}

/** Проверяет, что после нормализации телефон пригоден для отправки. */
export function isValidPhone(raw: string | null | undefined): boolean {
  return parsePhoneInput(raw).length > 0;
}

/** Нормализует значение для API; пустая строка, если телефон некорректен. */
export function phoneForApi(raw: string | null | undefined): string {
  return parsePhoneInput(raw);
}
